export default {
  path: '/system',
  name: 'system',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '系统管理',
    // keepAlive: false
  },
  children: [
    {
      // 系统-人员管理
      path: 'auth/menu',
      name: 'menuManage',
      component: () => import('../../views/System/AuthManage/MenuManage'),
      meta: { title: '菜单管理', keepAlive: false }
    },
    {
      // 系统-人员管理
      path: 'auth/role',
      name: 'authRole',
      component: () => import('../../views/System/AuthManage/RoleManage'),
      meta: { title: '角色管理', keepAlive: false }
    },
    {
      // 系统-角色管理
      path: 'roleManage',
      name: 'roleManage',
      component: () => import('../../views/System/RoleManage/RoleManageIndex'),
      meta: { title: '角色管理', keepAlive: false }
    },
    {
      // 系统-会员管理
      path: 'memberManage',
      name: 'memberManage',
      component: () => import('../../views/System/MemberManage/MemberManageIndex'),
      meta: { title: '会员管理', keepAlive: false }
    },
    {
      // 系统-会员管理-工号配置
      path: 'memberManage/workNumConfig',
      name: 'workNumConfig',
      // hidden: true,
      component: () => import('../../views/System/MemberManage/WorkNumConfig'),
      meta: { title: '工号配置', keepAlive: false }
    },
    {
      // 系统-人员管理
      path: 'personnelManage',
      name: 'personnelManage',
      component: () => import('../../views/System/PersonnelManage/PersonnelManageIndex'),
      meta: { title: '人员管理', keepAlive: false }
    },
    {
      // 系统-会员管理
      path: 'memberManage',
      name: 'memberManage',
      component: () => import('../../views/System/MemberManage/MemberManageIndex'),
      meta: { title: '会员管理', keepAlive: false }
    },
    {
      // 系统-会员管理-工号配置
      path: 'memberManage/workNumConfig',
      name: 'workNumConfig',
      // hidden: true,
      component: () => import('../../views/System/MemberManage/WorkNumConfig'),
      meta: { title: '工号配置', keepAlive: false }
    },
    {
      // 系统-应用管理
      path: 'appManage',
      name: 'appManage',
      component: () => import('../../views/System/AppManage/AppManage'),
      meta: { title: '应用管理', keepAlive: false }
    },
    {
      // 系统-应用管理-应用详情
      path: 'appManage/appDetail',
      name: 'appDetail',
      component: () => import('../../views/System/AppManage/AppDetail'),
      meta: { title: '应用详情', keepAlive: false }
    },
  ]
}